import { createContext, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useGTM from '../hooks/useGTM';

const GTMContext = createContext();

/**
 * Provider de Google Tag Manager
 * Inicializa el dataLayer y proporciona funciones GTM a toda la aplicación
 */
export const GTMProvider = ({ children }) => {
  const location = useLocation();
  const gtm = useGTM();

  // Inicializar dataLayer si no existe
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.dataLayer) {
      window.dataLayer = [];
    }
  }, []);

  // Enviar page_view automáticamente en cada cambio de ruta
  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const pageTitle = document.title || 'Liga ProKids';

    // Pequeño delay para asegurar que GTM esté cargado
    const timer = setTimeout(() => {
      gtm.sendPageView(pagePath, pageTitle);
    }, 100);

    return () => clearTimeout(timer);
  }, [location, gtm.sendPageView]);

  return (
    <GTMContext.Provider value={gtm}>
      {children}
    </GTMContext.Provider>
  );
};

// PropTypes para GTMProvider
GTMProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * Hook para usar GTM en cualquier componente
 */
export const useGTMContext = () => {
  const context = useContext(GTMContext);
  if (!context) {
    throw new Error('useGTMContext debe usarse dentro de GTMProvider');
  }
  return context;
};

export default GTMContext;
